import type { WidgetDefinition } from '../../../types/dashboard';

export const WIDGET_DEFINITIONS: WidgetDefinition[] = [
  // KPI Widgets
  {
    type: 'kpi_deals_value',
    category: 'kpi',
    name: 'Valor em Negociacoes',
    description: 'Total em valor de negociacoes abertas',
    icon: '💼',
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    defaultConfig: { color: 'indigo' },
  },
  {
    type: 'kpi_conversations',
    category: 'kpi',
    name: 'Conversas',
    description: 'Conversas aguardando resposta e nao lidas',
    icon: '💬',
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    defaultConfig: { color: 'green' },
  },
  {
    type: 'kpi_pending_tasks',
    category: 'kpi',
    name: 'Tarefas Pendentes',
    description: 'Quantidade de tarefas pendentes',
    icon: '📋',
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    defaultConfig: { color: 'yellow' },
  },
  {
    type: 'kpi_overdue_tasks',
    category: 'kpi',
    name: 'Tarefas Atrasadas',
    description: 'Quantidade de tarefas atrasadas',
    icon: '⚠️',
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    defaultConfig: { color: 'red' },
  },
  {
    type: 'kpi_total_sales',
    category: 'kpi',
    name: 'Vendas Totais',
    description: 'Valor total de vendas realizadas',
    icon: '💰',
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    defaultConfig: { color: 'emerald' },
  },
  {
    type: 'kpi_conversion_rate',
    category: 'kpi',
    name: 'Taxa de Conversao',
    description: 'Percentual de conversao de oportunidades',
    icon: '📈',
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    defaultConfig: { color: 'blue' },
  },
  {
    type: 'kpi_leads_today',
    category: 'kpi',
    name: 'Leads Hoje',
    description: 'Novos leads captados hoje',
    icon: '🎯',
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    defaultConfig: { color: 'purple' },
  },

  // Chart Widgets
  {
    type: 'chart_monthly_sales',
    category: 'chart',
    name: 'Vendas Mensais',
    description: 'Grafico de vendas mes a mes',
    icon: '📊',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: {},
  },
  {
    type: 'chart_conversion_funnel',
    category: 'chart',
    name: 'Funil de Conversao',
    description: 'Taxa de conversao por etapa do pipeline',
    icon: '🔻',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: {},
  },
  {
    type: 'chart_leads_trend',
    category: 'chart',
    name: 'Tendencia de Leads',
    description: 'Evolucao de leads nos ultimos 30 dias',
    icon: '📈',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: { period: 30 },
  },
  {
    type: 'chart_revenue_trend',
    category: 'chart',
    name: 'Tendencia de Receita',
    description: 'Evolucao de receita nos ultimos 30 dias',
    icon: '💹',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: { period: 30 },
  },
  {
    type: 'chart_top_products',
    category: 'chart',
    name: 'Top Produtos',
    description: 'Produtos mais vendidos',
    icon: '🏆',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: { limit: 10 },
  },

  // List Widgets
  {
    type: 'list_recent_deals',
    category: 'list',
    name: 'Negociacoes Recentes',
    description: 'Suas negociacoes mais recentes',
    icon: '📋',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: { limit: 5 },
  },
  {
    type: 'list_recent_activities',
    category: 'list',
    name: 'Proximas Atividades',
    description: 'Suas proximas atividades e tarefas',
    icon: '✅',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: { limit: 5 },
  },
  {
    type: 'list_recent_conversations',
    category: 'list',
    name: 'Conversas Recentes',
    description: 'Conversas que aguardam resposta',
    icon: '💬',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: { limit: 5 },
  },
  {
    type: 'list_at_risk_opportunities',
    category: 'list',
    name: 'Oportunidades em Risco',
    description: 'Oportunidades sem atividade recente',
    icon: '🚨',
    defaultSize: { w: 6, h: 4 },
    minSize: { w: 4, h: 3 },
    defaultConfig: { days_without_activity: 7 },
  },

  // Calendar Widget
  {
    type: 'mini_calendar',
    category: 'calendar',
    name: 'Mini Calendario',
    description: 'Calendario com indicadores de atividades',
    icon: '📅',
    defaultSize: { w: 4, h: 4 },
    minSize: { w: 3, h: 3 },
    defaultConfig: {},
  },
];

export function getWidgetDefinition(type: string): WidgetDefinition | undefined {
  return WIDGET_DEFINITIONS.find(w => w.type === type);
}

export function getWidgetsByCategory(category: string): WidgetDefinition[] {
  return WIDGET_DEFINITIONS.filter(w => w.category === category);
}
